import {inject, Injectable} from '@angular/core';
import {catchError, debounceTime, finalize, Observable, tap, throwError} from 'rxjs';
import {LoadingService, LoadingStates} from './loading.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  loadingService = inject(LoadingService);
  http = inject(HttpClient)
  headers = new HttpHeaders();
  ServerURL = environment.apiUrl;

  constructor() {
  }

  RequestHandler(
    runRequest: () => Observable<any>,
    RequestType = LoadingStates.UNKNOWN
  ): Observable<any> {
    let loadingId = this.loadingService.startLoading(RequestType);

    return runRequest().pipe(
      debounceTime(50),
      finalize(() => this.loadingService.finishLoading(loadingId)),
      catchError(error => {
        return throwError(() => error);
      })
    );
  }

  SendPost(method: string, data: any, type = LoadingStates.UNKNOWN, ServerURL = this.ServerURL) {
    return this.RequestHandler(() => {
      return this.http.post(ServerURL + method, data,);
    }, type);
  }

  SendPostWithProgress(method: string, data: any, type = LoadingStates.UNKNOWN, ServerURL = this.ServerURL) {
    return this.RequestHandler(() => {
      return this.http.post(ServerURL + method, data, {
      reportProgress: true,
      observe: 'events'
    });
    }, type);
  }

  SendPatch(method: string, data: any, type = LoadingStates.UNKNOWN, ServerURL = this.ServerURL) {
    return this.RequestHandler(() => {
      return this.http.patch(ServerURL + method, data,);
    }, type);
  }

  SendPut(method: string, data: any, type = LoadingStates.UNKNOWN, ServerURL = this.ServerURL) {
    return this.RequestHandler(() => {
      return this.http.put(ServerURL + method, data,);
    }, type);
  }

  SendGet(method: string, type = LoadingStates.UNKNOWN, ServerURL = this.ServerURL) {
    return this.RequestHandler(() => {
      return this.http.get(ServerURL + method,);
    }, type);
  }

  SendFileGet(method: string, type = LoadingStates.UNKNOWN, ServerURL = this.ServerURL) {
    return this.RequestHandler(() => {
      return this.http.get(ServerURL + method, { responseType: 'blob', observe: 'events', reportProgress: true, });
    }, type);
  }
  SendGetWithoutProgress(method: string, type = LoadingStates.UNKNOWN, ServerURL = this.ServerURL) {
    return this.http.get(ServerURL + method, { responseType: 'blob' });
  }

  SendDelete(method: string,data:any, type = LoadingStates.UNKNOWN, ServerURL = this.ServerURL) {
    return this.RequestHandler(() => {
      return this.http.delete( ServerURL + method,{body:data});
    }, type);
  }
}
